<template>
  <div class="field">
    <label class="label">{{ label }}</label>
    <div class="control">
      <textarea
        class="textarea"
        :placeholder="placeholder"
        :value="value"
        @input="onInput"
        :rows="rows"
      />
      <p class="help is-danger" v-if="errors && errors[0]">
        {{ $t(errors && errors[0]) }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "textarea-field",
  props: ["value", "label", "placeholder", "rows", "errors"],
  methods: {
    onInput(e) {
      this.$emit("input", e.target.value)
    }
  }
}
</script>
